import React, { useState } from "react";
import { Button, Card, Row, Col, Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const Music: React.FC = () => {
    const [playerLoaded, setPlayerLoaded] = useState(false);
    const { t } = useTranslation();

    return (
        <div style={{ padding: 24, height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Card
                variant="borderless"
                style={{
                    maxWidth: "100%",
                    width: "100%",  // Ensuring full width
                    height: "100%", // Ensuring full height
                    padding: 0, // Remove padding around the content
                    borderRadius: 8,
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
            >
                <Row justify="center" align="middle" style={{ minHeight: "calc(100vh - 96px)" }}>
                    <Col xs={24} sm={20} md={18} lg={16}>
                        <div style={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                            <Title level={1} style={{ marginBottom: 16 }}>{t("pages.music.title")}</Title>
                            {playerLoaded ? (
                                <iframe
                                    src="https://open.spotify.com/embed/playlist/61bo6vn4mNggSaPNhFFdmT?utm_source=generator&theme=0"
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                    loading="lazy"
                                    style={{
                                        borderRadius: 8,
                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                        height: "calc(80vh - 80px)", // Make the iframe take the whole remaining space (adjust as needed)
                                    }}
                                    title={t("pages.music.spotifyTitle")}
                                />
                            ) : (
                                <Card bordered>
                                    <Typography.Paragraph>{t("pages.music.spotifyNotice")}</Typography.Paragraph>
                                    <Button type="primary" size="large" onClick={() => setPlayerLoaded(true)}>
                                        {t("pages.music.loadSpotify")}
                                    </Button>
                                </Card>
                            )}
                        </div>
                    </Col>
                </Row>
            </Card>
        </div>
    );
};

export default Music;
